import { render, staticRenderFns } from "./ActivityProduct.vue?vue&type=template&id=4aa695ea&scoped=true&"
import script from "./ActivityProduct.vue?vue&type=script&lang=js&"
export * from "./ActivityProduct.vue?vue&type=script&lang=js&"
import style0 from "./ActivityProduct.vue?vue&type=style&index=0&id=4aa695ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aa695ea",
  null
  
)

export default component.exports